export default Object.freeze({
  Maestro: 16,
  AsistenteServicio: 17,
  FuncionarioDEPR: 35,
  TerapistaAcuatico: 24,
  TerapistaFisico: 13,
  TerapistaHablaYLenguaje: 14,
  TerapistaOcupacional: 15,
});
